<!--
발송작업 > 요청메모
-->
<template>
    <div class="uk-flex">
        <div class="title">
            <i class="material-icons">comment</i>
            발송작업 요청메모
        </div>
        <div class="body uk-width-expand">
            <request
                :request="displayMessage"
                :highlight="noCheckingJob"
                style="background-color: #ff6;"
            >
            </request>

        </div>
    </div>
</template>

<script>
    export default {
        components: {
            'request': require('./request.vue').default,
        },
        props: {
            // 요청메모
            memo: String,

            // 재고상품
            stockProd: Object,
        },
        data: function () {
            return {
                // (bool) 확인여부
                checked: false,
            };
        },
        computed: {
            /**
             * 화면에 표시될 메세지
             *  - 메세지가 없는경우, 기본 메세지를 출력해준다.
             *
             * @return string
             */
            displayMessage() {
                // 등록된 메모가 있는경우
                if (this.memo) {
                    return this.memo;
                }

                // 무자료 발송인경우
                if (this.stockProd && _.includes(this.stockProd.name, "무자료")) {
                    return '무자료 미검수 상품 → 반드시 검수 후 발송하세요';
                }

                return '반드시 검수 후 발송하세요';

            },

            /**
             * 무검수요청여부
             *
             * @return boolean
             */
            noCheckingJob() {
                return _.includes(this.memo, "(무검수 발송)");
            },
        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
.title {
    text-align: left;
    width: 12rem;
    color: #000;
    font-size: 1.25rem;

    margin-right: 2rem;

    .material-icons {
        font-size: 1.75rem;
    }
}
.body {
    font-weight: bold;
}

</style>